import { cn } from '@/lib/utils';
import { textoEnBurbuja } from './alerts-format';

/**
 * La burbuja roja con el número de conversaciones con mensajes sin ver.
 *
 * Es el «hay algo nuevo» del panel: se pinta encima del icono de Mensajes del header y al final de la
 * fila «Conversaciones» del menú lateral. El número es de CONVERSACIONES, no de mensajes (el listado
 * del backend no dice cuántos mensajes llegaron desde la última visita: ver `alerts-format.ts`), y a
 * partir de 10 se pinta «9+».
 *
 * Accesibilidad: la burbuja es decorativa (`aria-hidden`) y quien lleva el texto es el acceso que la
 * contiene —`describeBurbujaAlertas` en su `aria-label`—, porque un lector de pantalla no debe
 * anunciar un «3» suelto.
 */

export interface InboxAlertsBubbleProps {
  /** Conversaciones con mensajes nuevos sin ver (0 = no se pinta nada: sin burbujas no hay ruido). */
  total: number;
  /**
   * `icono`: pegada a la esquina superior derecha de un icono (el contenedor tiene que ser
   * `relative`), con un anillo del color de la superficie para que se despegue del icono.
   * `fila`: en línea, al final de un ítem del menú.
   */
  variant?: 'icono' | 'fila';
  className?: string;
}

export function InboxAlertsBubble({
  total,
  variant = 'icono',
  className,
}: InboxAlertsBubbleProps) {
  if (total <= 0) return null;

  return (
    <span
      aria-hidden="true"
      className={cn(
        'flex h-4 min-w-4 items-center justify-center rounded-pill bg-danger px-1 text-micro font-bold text-white tabular',
        variant === 'icono' ? 'absolute -top-0.5 -right-0.5 ring-2 ring-surface' : null,
        className,
      )}
    >
      {textoEnBurbuja(total)}
    </span>
  );
}
